import { useParams } from 'react-router-dom'
import CustomerForm from 'pages/shared/CustomerForm'

import Spinner from 'components/Spinner'

import CustomerModel from 'models/Customer'

import useCustomer from 'hooks/useCustomer'
import { useSessionContext } from 'hooks/SessionContext'
import { SinglePanePage } from 'styles/shared'

const EditCustomer = () => {
  const { customerId } = useParams()
  const { session: { readOnly, dealerId } } = useSessionContext()
  const { customer, isCustomerLoaded } = useCustomer(dealerId, customerId, 0)

  if (customerId && !isCustomerLoaded) {
    return <Spinner variant="page" />
  }

  return (
    <SinglePanePage>
      <CustomerForm
        customer={new CustomerModel(customer)}
        dealerId={dealerId}
        readOnly={readOnly}
        title="Edit Customer"
        readOnlyMessage="Read-only view: can't edit customer"
        displayDeleteButton
      />
    </SinglePanePage>
  )
}

export default EditCustomer
